import React, { useState } from 'react';
import {
  Head,
  useRouteData,
  useSiteData,
} from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import CredentialCalloutGrouping from './components/credentialCalloutGrouping';
import FrConnectSection from './components/frConnectSection';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import Metadata from './components/metadata';
import PodcastEpisodeGrouping from './components/podcastEpisodeGrouping';
import SuspectEmailCaptureFormSection from './components/suspectEmailCaptureFormSection';
import GetToKnowYourHost from './components/getToKnowYourHost';
import SectionVideoPlayer from './components/sectionVideoPlayer';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/podcast-hero-desktop.webp';
import highResMobileImage from './components/heroSection/images/podcast-hero-mobile.webp';
// dislaimer footnotes
import { BasedOnClientData } from '../../utils/disclaimerFootnotes/disclaimerFootnotes';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const {
    pageProps,
    podcastEpisodeItems,
  } = useRouteData();
  // We don't want to load recaptcha on page load (for performance reasons) so we will load it once the in page lead for is engaged with
  const [loadRecaptcha, setLoadRecaptcha] = useState(false);

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      config={config}
      dynamicConfig={dynamicConfig}
      useReCaptcha={loadRecaptcha}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Podcast',
          linkUrl: '/podcast/',
          linkAriaLabel: 'Northwestern Mutual Podcast',
        },
      ]}
      disclaimerFootnotes={[
        <>
          <sup>1</sup>&nbsp;Ranking for Northwestern Mutual Investment Services, LLC. Measured by 2022 Revenue. Source: InvestmentNews, May 2023.
        </>,
        <>
          <sup>2</sup>&nbsp;Northwestern Mutual continues to have the highest available financial strength ratings awarded to any U.S. life insurer by all four of the major rating agencies: A.M. Best Company, A&#43;&#43; &#40;highest&#41;, 8&#47;23&#59; Fitch Ratings, AAA &#40;highest&#41;, 8&#47;23&#59; Moody&#39;s Investors Service, Aa1 &#40;second highest&#41;, 11&#47;23&#59; S&#38;P Global Ratings, AA&#43; &#40;second highest&#41;, 5&#47;23. Third&#45;party ratings are subject to change. Ratings are for The Northwestern Mutual Life Insurance Company and Northwestern Long Term Care Insurance Company.
        </>,
        <>
          {BasedOnClientData(3)}
        </>,
      ]}>
      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <IntroSection />

      <PodcastEpisodeGrouping podcastEpisodeItems={podcastEpisodeItems} />

      <GetToKnowYourHost />

      <SectionVideoPlayer />

      <SuspectEmailCaptureFormSection
        loadRecaptcha={loadRecaptcha}
        setLoadRecaptcha={setLoadRecaptcha}
      />

      <CredentialCalloutGrouping />

      <FrConnectSection />

    </Page>
  );
};
